import { css } from "styled-components";

export const boxshadowSmallStyle = css`
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const boxshadowMediumStyle = css`
    box-shadow:
        0px 0.67932px 3.62304px 0px rgba(0, 0, 0, 0.02),
        0px 1.87823px 10.01724px 0px rgba(0, 0, 0, 0.03),
        0px 4.52206px 24.11766px 0px rgba(0, 0, 0, 0.05),
        0px 15px 80px 0px rgba(0, 0, 0, 0.04);
`;

export const boxshadowLargeStyle = css`
    box-shadow:
        0px 0.67932px 3.62304px 0px rgba(0, 0, 0, 0.02),
        0px 1.87823px 10.01724px 0px rgba(0, 0, 0, 0.03),
        0px 4.52206px 24.11766px 0px rgba(0, 0, 0, 0.05),
        0px 15px 80px 0px rgba(0, 0, 0, 0.04);
`;
